import React, { Component } from 'react';
import '../../css/match-stats.css';
import classNames from 'classnames';


class MatchStats extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: this.getIsOpenState(),
        };
    }

    getIsOpenState() {
        // Retrieve the object from storage
        let isOpen = true;
        try {
            isOpen = JSON.parse(localStorage.getItem('settings')).matchPage.isOpenStats
        } catch (error) { }
        return isOpen;
    }

    setIsOpenState(newState) {
        // Retrieve the object from storage
        let storedState = JSON.parse(localStorage.getItem('settings'));
        storedState = {
            ...storedState,
            matchPage: {
                ...storedState.matchPage,
                isOpenStats: newState,
            }
        }
        // Put the object into storage
        localStorage.setItem('settings', JSON.stringify(storedState));
    }

    toggleMenu() {
        const newState = !this.state.open;
        this.setIsOpenState(newState);
        this.setState({
            open: newState
        })
    }

    renderSortedStatistics() {
        let sortedArray = [
            { name: "Posse de bola", type: "possession", value_team_A: 0, value_team_B: 0, isLast: true },
            { name: "Golos", type: "goals", value_team_A: 0, value_team_B: 0 },
            { name: "Remates enquadrados", type: "shots_on_target", value_team_A: 0, value_team_B: 0 },
            { name: "Remates bloqueados", type: "shots_blocked", value_team_A: 0, value_team_B: 0 },
            { name: "Remates fora", type: "shots_off_target", value_team_A: 0, value_team_B: 0 },
            { name: "Livres", type: "free_kicks", value_team_A: 0, value_team_B: 0 },
            { name: "Pontapés de baliza", type: "goal_kicks", value_team_A: 0, value_team_B: 0 },
            { name: "Lançamentos", type: "throw_ins", value_team_A: 0, value_team_B: 0 },
            { name: "Cantos", type: "corners", value_team_A: 0, value_team_B: 0, isLast: true },
            { name: "Ataques", type: "attacks", value_team_A: 0, value_team_B: 0 },
            { name: "Ataques perigosos", type: "dangerous_attacks", value_team_A: 0, value_team_B: 0 },
            { name: "Fora de jogo", type: "offsides", value_team_A: 0, value_team_B: 0, isLast: true },
            { name: "Substituições", type: "substitutions", value_team_A: 0, value_team_B: 0, isLast: true },
            { name: "Cartões vermelhos", type: "red_cards", value_team_A: 0, value_team_B: 0 },
            { name: "Segundo cartão amarelo", type: "yellow_red_cards", value_team_A: 0, value_team_B: 0 },
            { name: "Cartões amarelos", type: "yellow cards", value_team_A: 0, value_team_B: 0 },
            { name: "Faltas", type: "fouls", value_team_A: 0, value_team_B: 0, isLast: true },
        ];
        this.props.data.statistics.forEach((each) => {
            let index = sortedArray.findIndex(stat => stat.type.toString() === each.type.toString());
            if (index !== -1) {
                sortedArray[index].value_team_A = each.value_team_A;
                sortedArray[index].value_team_B = each.value_team_B;
            }
        })
        return (
            sortedArray.map((each, index) => {
                let total = each.value_team_A + each.value_team_B;
                let valuestatsA = (total === 0 ? 0 : (each.value_team_A / (total) * 100));
                let valuestatsB = (total === 0 ? 0 : (each.value_team_B / (total) * 100));
                return (
                    <tr className={classNames("stats", each.isLast && "space-bottom")} key={index}>
                        <td className="bar-stats" align="right">
                            <div className={classNames("bar", "home", (valuestatsA < valuestatsB) && "lose")} style={{ border: '1px solid #303488', width: valuestatsA }}></div>
                        </td>
                        <td className="value-number-teamA">{each.value_team_A}</td>
                        <td className="values-stats">{each.name}</td>
                        <td className="value-number-teamB">{each.value_team_B}</td>
                        <td className="bar-stats">
                            <div className={classNames("bar", "away", (valuestatsB < valuestatsA) && "lose")} style={{ border: '1px solid #949695', width: valuestatsB }}></div>
                        </td>
                    </tr>
                )
            })
        )
    }

    render() {
        return (
            <div className="match-stats" >
                {
                    this.props.data.statistics !== '[]' &&
                    this.props.data.statistics !== '[]' &&
                    <div className="title-stats" onClick={() => this.toggleMenu()}>
                        <div className="icons">
                            <span className="ball">
                                <img src="/img/stats.svg" alt="match stats" width="20" />
                            </span>
                            <h2>Estatísticas</h2>
                        </div>
                        <img className={classNames(this.state.open && "rotate-icon")} src="/img/arrow.svg" alt="arrow" width="20" />
                    </div>
                }
                <table className={classNames("table-stats", !this.state.open && 'd-none')}>
                    <tbody>
                        <tr>
                            <td className="td-stats-t1-logo">
                                <img src={"https://academia.r.worldssl.net/addons/default/modules/stats/img/team/150x150/" + this.props.data.team_A_id + ".png"} alt={this.props.data.team_A_name} border="0"></img>
                            </td>
                            <td className="td-stats-table">
                                <center>
                                    <div className="div-stats-table">
                                        <table className="stats-table">
                                            <tbody className="stats-body">
                                                {
                                                    this.renderSortedStatistics()
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </center>
                            </td>
                            <td className="td-stats-t2-logo">
                                <img src={"https://academia.r.worldssl.net/addons/default/modules/stats/img/team/150x150/" + this.props.data.team_B_id + ".png"} alt={this.props.data.team_B_name} border="0"></img>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="10" align="right" height="30"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default MatchStats;